import React from 'react'
import { DatePicker, formatReturnDate } from '@twilio-paste/core/date-picker'

const Calendar = ({ curInteractives, sendMessage }) => {
  const today = new Date()
  const year = today.getFullYear()
  const month = today.getMonth() + 1
  const day = today.getDate()

  return (
    <DatePicker
      aria-describedby='calendat_text'
      id='calendar'
      name='calendar'
      value={`${year}-${month.toString().padStart(2, '0')}-${day}`}
      onChange={(e) => sendMessage(formatReturnDate(e.target.value, 'MM/dd/yyyy'))}  
    />
  )
}

export default Calendar
